import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import CalendarShare from '../../entities/calendarShare';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteCalendarShare(): boolean {
return true;
}
export function collectCalendarShareDeleteImpact(calendarShare: CalendarShare, context: DeleteImpactContext): void {
const key = 'calendarShare:' + calendarShare.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactCalendarShare(calendarShare: CalendarShare): DeleteImpact {
const context = deleteImpactContext();
collectCalendarShareDeleteImpact(calendarShare, context);
return deleteImpactCounts(context);
}
export function deleteCalendarShare(calendarShare: CalendarShare, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteCalendarShare()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectCalendarShareDeleteImpact(calendarShare, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || calendarShare.id};
}
const key = 'calendarShare:' + calendarShare.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = calendarShare.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.CalendarShareActions.removeCalendarShareQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
